var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.836 2.428C15.836 2.428 15.68 1.325 15.199 0.841C14.59 0.204 13.908 0.2 13.596 0.163C11.359 1.04308e-07 7.999 0 7.999 0H7.993C7.993 0 4.634 1.04308e-07 2.396 0.163C2.083 0.201 1.402 0.204 0.793 0.841C0.312 1.325 0.159 2.428 0.159 2.428C0.159 2.428 0 3.722 0 5.019V6.232C0 7.526 0.159 8.823 0.159 8.823C0.159 8.823 0.315 9.926 0.793 10.411C1.402 11.048 2.202 11.027 2.559 11.095C3.84 11.217 8 11.254 8 11.254C8 11.254 11.363 11.248 13.6 11.088C13.913 11.051 14.594 11.047 15.203 10.41C15.684 9.926 15.84 8.822 15.84 8.822C15.84 8.822 15.999 7.528 15.999 6.231V5.018C15.996 3.724 15.837 2.427 15.837 2.427L15.836 2.428ZM6.342 7.703V3.206L10.664 5.462L6.342 7.703V7.703Z",
    fill: "#545454"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTube);
export default __webpack_public_path__ + "static/media/icon_tube.fc25cdc927b08a6fbde5f9e4942ede12.svg";
export { ForwardRef as ReactComponent };